import { createContext, useContext } from 'react';

const ProgramContext = createContext<CmsProgram>({} as CmsProgram);

export const useProgram = () => useContext(ProgramContext);

export default ProgramContext;
